// @flow
export const ROOT_ROUTE = '/';
// export const ROOT_ROUTE_CATEGORY = '/:categoryId';
// export const LOGIN_ROUTE = '/login';
// export const ALL_CATEGORIES_ROUTE = '/year-summary/:categoryId';
// export const ARTICLE_ROUTE = `${ALL_CATEGORIES_ROUTE}/:articleId`;
export const INTRO_ROUTE = '/intro';
export const FIRST_YNET_COURSE_ROUTE = `/first-ynet-course`;
export const SECOND_YNET_COURSE_ROUTE = `/second-ynet-course`;
